/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {Loader} from '../../components/Loader';
import { StackParams } from '../../../data/types/navigation';
import { HeaderScreen } from '../../components/Header/HeaderScreen';
import { ProduitItem } from '../../components/ProduitItem';
import { IData, IDataWs, IDisplay } from '../../../data/types/interface/demanderDevis';

type NavigationProps = StackNavigationProp<StackParams, 'DemanderDevis'>;

interface Props {
  getCategorieTypeassurance: any;
}

export function DemanderDevisScreen(props: Props) {
  const {navigate} = useNavigation<NavigationProps>();
  const {getCategorieTypeassurance} = props;
  const [listItem, setListItem] = useState<Array<IDataWs>>();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    getCategorieTypeassurance({}, (res: any) => {
      setLoading(true);
      setListItem(
        res && res.data && res.data.items.length > 0
          ? res.data.items
          : undefined,
      );
      setLoading(false);
    });
  }, [getCategorieTypeassurance]);

  const aList: IData[] = [
    {
      libelle: 'Famille',
      navigate: () => {
        navigate('DemanderSimulationFamille');
      },
      destinationPage: 'DemanderSimulationFamille',
      id: '',
      data: '',
      headerTitle: 'Demander un devis',
    },
    {
      libelle: 'Epargne et prévoyance',
      navigate: () => {
        navigate('Cotisation');
      },
      destinationPage: 'Cotisation',
      id: '',
      data: '',
      headerTitle: 'Demander un devis',
    },
  ];

  const datas = listItem
    ? aList.map((elt, i) => {
        elt.libelle = listItem[i]?.nom || elt.libelle;
        elt.id = listItem[i]?.id || elt.id;
        elt.imageUrl = listItem[i]?.imageUrl || elt.imageUrl;
        elt.action = listItem[i]?.action || elt.action;
        return elt;
      })
    : [];

  const display: IDisplay = {items: []};
  display.items = datas;
  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Demander un devis"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <View>
          <ProduitItem data={display} />
        </View>
      )}
    </View>
  );
}
export const DemanderDevis: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemanderDevisScreen);
